/* =============================================================================
   BARK WITH BUSTER — Custom JS
   ============================================================================= */

/* =============================================================================
   MOQ ENFORCER + BUY BOX UPDATE
   Applies to all products tagged: min-qty-3
   Reads custom.min_quantity metafield (default: 3)
   ============================================================================= */

(function () {
  if (!window.location.pathname.includes('/products/')) return;

  const minQtyEl = document.getElementById('bwb-min-qty');
  const MOQ = minQtyEl ? parseInt(minQtyEl.dataset.min, 10) || 3 : 3;

  const productTagsEl = document.getElementById('bwb-product-tags');
  const productTags = productTagsEl ? productTagsEl.dataset.tags : '';
  const isMinQtyProduct = productTags.includes('min-qty-3');

  if (!isMinQtyProduct) return;

  // ── 1. ENFORCE MINIMUM QUANTITY ──────────────────────────────────────────
  function enforceMinQty() {
    const qtyInputs = document.querySelectorAll(
      'input[name="quantity"], .quantity__input, input.qty'
    );
    qtyInputs.forEach(function (input) {
      input.setAttribute('min', MOQ);
      if (parseInt(input.value, 10) < MOQ) input.value = MOQ;
      input.addEventListener('change', function () {
        if (parseInt(this.value, 10) < MOQ) this.value = MOQ;
      });
    });

    const decrementBtns = document.querySelectorAll(
      '.quantity__button[name="minus"], button.qty-minus, [data-action="decrement-quantity"]'
    );
    decrementBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        const input = btn.closest('.quantity, .qty-wrapper')
          ? btn.closest('.quantity, .qty-wrapper').querySelector('input')
          : document.querySelector('input[name="quantity"]');
        if (input && parseInt(input.value, 10) <= MOQ) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.value = MOQ;
        }
      }, true);
    });
  }

  // ── 2. UPDATE BUY BOX ────────────────────────────────────────────────────
  function updateBuyBox() {
    const priceEl = document.querySelector(
      '.price__regular .price-item--regular, .product__price .money, [class*="price"] .money'
    );
    if (!priceEl) return;

    const rawPrice = priceEl.textContent.replace(/[^0-9.]/g, '');
    const unitPrice = parseFloat(rawPrice);
    if (isNaN(unitPrice)) return;

    const totalPrice = (unitPrice * MOQ).toFixed(2);
    const formattedTotal = '$' + parseFloat(totalPrice).toLocaleString('en-AU', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    const formattedUnit = '$' + unitPrice.toLocaleString('en-AU', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });

    // Update ATC button
    const atcBtn = document.querySelector(
      'button[name="add"], .product-form__submit, #product-add-to-cart'
    );
    if (atcBtn) {
      atcBtn.innerHTML =
        'Add ' + MOQ + ' Bulk Bags – ' + formattedTotal +
        '<span style="display:block;font-size:12px;font-weight:400;margin-top:3px;opacity:0.85;">' +
        'Minimum order includes ' + MOQ + ' × 1kg bags</span>';
    }

    // Inject MOQ messaging below price
    if (!document.getElementById('bwb-moq-messaging')) {
      const moqMsg = document.createElement('div');
      moqMsg.id = 'bwb-moq-messaging';
      moqMsg.style.cssText = 'margin:8px 0 12px;font-size:14px;line-height:1.5;color:#333;';
      moqMsg.innerHTML =
        '<strong>Minimum Order: ' + MOQ + ' × 1kg Bags</strong><br>' +
        '<span style="color:#555;">(' + formattedUnit + ' per bag)</span>';

      const priceWrapper = priceEl.closest('.price, .product__price, [class*="price-wrapper"]');
      if (priceWrapper && priceWrapper.parentNode) {
        priceWrapper.parentNode.insertBefore(moqMsg, priceWrapper.nextSibling);
      }
    }
  }

  // ── 3. INIT ───────────────────────────────────────────────────────────────
  function init() {
    enforceMinQty();
    updateBuyBox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 800);

})();
// Fix: Update main price display on variant change
document.addEventListener('DOMContentLoaded', function() {
  function updatePriceDisplay() {
    var priceEl = document.querySelector('.product-price-near-title');
    if (!priceEl) return;

    var atcBtn = document.querySelector('button[name="add"]');
    if (atcBtn) {
      var match = atcBtn.textContent.match(/\$[\d,]+\.?\d*/);
      if (match) {
        priceEl.textContent = match[0];
      }
    }
  }

  // Listen on all variant inputs
  document.querySelectorAll('input[name="id"], select[name="id"]').forEach(function(el) {
    el.addEventListener('change', updatePriceDisplay);
  });

  // Watch for ATC button text changes
  var atcBtn = document.querySelector('button[name="add"]');
  if (atcBtn) {
    var observer = new MutationObserver(updatePriceDisplay);
    observer.observe(atcBtn, { subtree: true, characterData: true, childList: true });
  }
});
